import { render, staticRenderFns } from "./ACL.vue?vue&type=template&id=83710216&"
import script from "./ACL.vue?vue&type=script&lang=js&"
export * from "./ACL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports